module.exports = __webpack_public_path__ + "static/media/vincent_riemer.b82c3119.jpg";